
import {
  AjaxDelete,
  AjaxGet,
  AjaxPost,
  Alert,
  Confirm,
  Prompt,
} from "../App.vue";
import Vue from "vue";
import { GetClientRegistrationApproveURL, GetClientRegistrationURL } from "../../../shared/Shared";
import Client from "../../../shared/Client";
import ClientInfo from "@/components/ClientInfo.vue";

class ClientRequestsDataClass {
  public ClientRequests: { [key: string]: Client } = {};
}

export default Vue.extend({
  name: "ClientRequests",

  data() {
    return new ClientRequestsDataClass();
  },

  components: {
    ClientInfo
  },

  computed: {
    clientNameList(): string[] {
      return Object.keys(this.ClientRequests);
    },
  },

  created() {
    this.refresh();
  },

  methods: {
    Approve(clientName: string) {
      let cancelled = false;
      const client = this.ClientRequests[clientName];

      Confirm("Are you sure you wish to approve " + clientName + "?")
        .then((value) => {
          if (value === false) {
            cancelled = true;
            return null;
          }

          return Prompt(
            "Please enter the default password for " +
            client.primaryContact?.email
          );
        })
        .then((promptResult) => {
          if (
            !promptResult ||
            promptResult.clickedOk === false ||
            cancelled ||
            !promptResult.text
          ) {
            cancelled = true;
            return null;
          }

          return AjaxPost(
            GetClientRegistrationApproveURL(clientName),
            {
              password: promptResult.text,
            },
            true
          );
        })
        .then(() => {
          if (cancelled) {
            return null;
          }

          this.refresh();
        })
        .catch((err) => Alert("Unable to approve client", err));
    },

    Decline(clientName: string) {
      let cancelled = false;

      Confirm("Are you sure you wish to decline " + clientName + "?")
        .then((value) => {
          if (value === false) {
            cancelled = true;
            return null;
          }
          return AjaxDelete(GetClientRegistrationURL(clientName));
        })
        .then(() => {
          if (cancelled) {
            return null;
          }

          this.refresh();
        })
        .catch((err) => Alert("Unable to decline client", err));
    },

    refresh() {
      AjaxGet<{ [key: string]: Client } | null>(
        GetClientRegistrationURL(),
        true
      ).then((data) => {
        if (data) {
          this.ClientRequests = data;
        } else {
          this.ClientRequests = {};
        }
      });
    },
  },
});
